import type { PathStep } from '~/pages/backoffice/admin/sessions/path-step'

/** Un palier : des étapes consécutives qui ouvrent le même jour. */
export type PathStage = { unlockAt: string, steps: PathStep[] }

/**
 * Regroupe les étapes consécutives partageant la même date d'ouverture.
 *
 * C'est toute l'implémentation de la notion de « palier » : le client raisonne
 * par vagues (« ces deux modules le 1er, ces trois-là le 15 »), mais le palier
 * n'est PAS une entité — juste des modules qui partagent une date (ADR 0002,
 * D4). Une table de plus n'apporterait qu'un nom de palier, que personne n'a
 * demandé.
 */
export function groupIntoStages(steps: PathStep[]): PathStage[] {
  const stages: PathStage[] = []
  for (const step of steps) {
    const last = stages.at(-1)
    if (last && last.unlockAt === step.unlockAt) last.steps.push(step)
    else stages.push({ unlockAt: step.unlockAt, steps: [step] })
  }
  return stages
}
